import React, { Suspense, useState } from 'react';
import { RetailersDataList } from '../components/RetailersDataList';
import { ListSearchAndLimit } from '../../common/components/ListSearchAndLimit';
import { PageFrame } from '../../common/components/PageFrame';
import { AddButton } from '../../common/components/AddButton';
import { SearchBar } from '../../common/components/SearchBar';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';

export const RetailersListPage = () => {
  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  return (
    <PageFrame
      title="Online Retail"
      topBarContent={
        <>
          <SearchBar placeholder="Search retailers" onChange={setQuery} />
          <AddButton text="Add Retailer" to="/retailers/add" />
        </>
      }
    >
      <ListSearchAndLimit
        setLimit={setLimit}
        limit={limit}
        onSearch={setQuery}
      />
      <Suspense fallback={<LoadingSpinner />}>
        <RetailersDataList
          offset={offset}
          limit={limit}
          query={query}
          setOffset={setOffset}
        />
      </Suspense>
    </PageFrame>
  );
};
